import ScrollPin from "./scroll/scroll-pin";
import {CUSTOM_SCROLL, isMobile, scrollSetting} from "../common/globalVars";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import {HtmlUtil} from "../utils/HtmlUtil";
import {gsap} from "gsap";

export default class MotionScrollBox {
    constructor(triggerEl, targetEl, scrollRatio) {
        this.triggerEl = triggerEl;
        this.targetEl = targetEl;
        this.scrollRatio = scrollRatio;
        this.lineHolderEl = triggerEl.querySelector('.line-holder');
        this.init();
    }

    init() {
        this.addEvent();
    }

    addEvent() {
        this.onScrollHandler({detail:0});
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
        CustomEventHandler.addHandler(window, 'resize', (e)=>this.onResizeHandler(e));
    }

    onScrollHandler(e) {
        let triggerTop = HtmlUtil.getPos(this.targetEl).y;
        let triggerHeight =  parseFloat(window.getComputedStyle(this.triggerEl).height);
        let velocity = e.detail - triggerTop;

        let maxVelocity = triggerHeight - window.innerHeight;

        let targetElHeight = parseFloat(window.getComputedStyle(this.targetEl).height);
        velocity = velocity  - targetElHeight/2 + window.innerHeight/2;

        let lineHeight = parseInt(window.getComputedStyle(this.lineHolderEl).height);

        if (targetElHeight > window.innerHeight) {
            maxVelocity = maxVelocity - targetElHeight - 50;
        } else {
            maxVelocity = maxVelocity - targetElHeight / 2 - 50;
        }

        if (lineHeight > window.innerHeight) {
            let linePadding = lineHeight - window.innerHeight;
            maxVelocity = maxVelocity + linePadding;
        }


        if (velocity>0) {
            if (velocity > maxVelocity) {
                velocity = maxVelocity;
            }
            if (scrollSetting.smooth) this.targetEl.style.transform = `translate3d(0, ${velocity}px, 0)`;

        } else {
            if (scrollSetting.smooth) this.targetEl.style.transform = `translate3d(0, 0, 0)`;
        }

        if (!scrollSetting.smooth) velocity = e.detail - HtmlUtil.getPos(this.triggerEl).y;

            if (velocity > maxVelocity * this.scrollRatio) {
                this.targetEl.classList.add('onScroll');
            } else {
                this.targetEl.classList.remove('onScroll');
            }

    }

    onResizeHandler(e) {
        if (!scrollSetting.smooth) return;
        let y = gsap.getProperty(document.querySelector('main'), 'y');
        this.scrollTop = y*-1;
        this.onScrollHandler({detail:y*-1});
    }
}
